export default {
    data: () => ({
        translations: {
            primaryEmail: {
                el: "Κύριο Email",
                en: "Primary Email",
                it: "E-mail Primario"
            },
            secondaryEmail: {
                el: "Δευτερεύον Email",
                en: "Secondary Email",
                it: "Email Secondaria"
            },
            save: {
                el: "Αποθήκευση",
                en: "Save",
                it: "Salva"
            }
        }
    })
};
